import gql from 'graphql-tag';

import { MatchesAlbumFolderDetails } from './album-folder';

export const MatchesAlbumDetails = gql`
  fragment MatchesAlbumDetails on Album {
    id
    name
    album_type
    album_subtype
    social_share_enabled
    hash_code
    join_code
    slideshow {
      status
    }
    root_album_folder {
      ...MatchesAlbumFolderDetails
    }
  }
  ${MatchesAlbumFolderDetails}
`;
